var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "doc-review-page" }, [
    _vm.loading
      ? _c("div", { staticClass: "state-message" }, [
          _c("div", { staticClass: "spinner" }),
          _vm._v(" "),
          _c("p", [_vm._v("Loading documents…")])
        ])
      : _vm.data.length === 0
      ? _c("div", { staticClass: "state-message empty" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "48",
                height: "48",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.5"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v("No documents pending review")])
        ])
      : _c(
          "div",
          { staticClass: "doc-grid" },
          _vm._l(_vm.data, function(doc, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "doc-card",
                class: {
                  "is-approved": doc._status === "approved",
                  "is-denied": doc._status === "denied"
                }
              },
              [
                _c("div", { staticClass: "doc-image-wrap" }, [
                  doc._src
                    ? _c("img", {
                        staticClass: "doc-image",
                        attrs: {
                          src: doc._src,
                          alt: "Document " + (index + 1)
                        },
                        on: {
                          click: function($event) {
                            _vm.lightbox = doc._src
                          }
                        }
                      })
                    : _c("div", { staticClass: "doc-image-placeholder" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "40",
                              height: "40",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                              }
                            })
                          ]
                        )
                      ]),
                  _vm._v(" "),
                  doc._status
                    ? _c("div", { staticClass: "status-badge" }, [
                        doc._status === "approved"
                          ? _c("span", [_vm._v("✓ Approved")])
                          : _c("span", [_vm._v("✕ Denied")])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "doc-info" }, [
                  _c("p", { staticClass: "doc-name" }, [
                    _vm._v(_vm._s(_vm.getDocName(doc)))
                  ]),
                  _vm._v(" "),
                  _vm.getDocMeta(doc)
                    ? _c("p", { staticClass: "doc-meta" }, [
                        _vm._v(_vm._s(_vm.getDocMeta(doc)))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "doc-tags" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.openJoborder(doc)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "doc-tag" }, [
                          _vm._v("Job Order ID: 11-" + _vm._s(doc.joborderid))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "doc-tag" }, [
                      _vm._v("Schedule ID: " + _vm._s(doc.jobscheduleid))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "doc-tag" }, [
                      _vm._v("User: " + _vm._s(doc.user))
                    ])
                  ])
                ]),
                _vm._v(" "),
                !doc._status
                  ? _c(
                      "div",
                      { staticClass: "doc-actions" },
                      [
                        !doc._pending
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-approve",
                                  on: {
                                    click: function($event) {
                                      return _vm.startAction(
                                        doc,
                                        index,
                                        "approved"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.5"
                                      }
                                    },
                                    [
                                      _c("polyline", {
                                        attrs: { points: "20 6 9 17 4 12" }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                Select\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-deny",
                                  on: {
                                    click: function($event) {
                                      return _vm.startAction(
                                        doc,
                                        index,
                                        "denied"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.5"
                                      }
                                    },
                                    [
                                      _c("line", {
                                        attrs: {
                                          x1: "18",
                                          y1: "6",
                                          x2: "6",
                                          y2: "18"
                                        }
                                      }),
                                      _c("line", {
                                        attrs: {
                                          x1: "6",
                                          y1: "6",
                                          x2: "18",
                                          y2: "18"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v("\n                Deny\n            ")
                                ]
                              )
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  class:
                                    doc._pending === "approved"
                                      ? "btn-confirm-approve"
                                      : "btn-confirm-deny",
                                  on: {
                                    click: function($event) {
                                      return _vm.confirmAction(doc, index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Confirm " +
                                      _vm._s(
                                        doc._pending === "approved"
                                          ? "select"
                                          : "deny"
                                      ) +
                                      "?\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-cancel",
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelPending(doc, index)
                                    }
                                  }
                                },
                                [_vm._v("✕")]
                              )
                            ]
                      ],
                      2
                    )
                  : _c(
                      "div",
                      { staticClass: "doc-actions doc-actions--resolved" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-undo",
                            on: {
                              click: function($event) {
                                return _vm.undo(doc, index)
                              }
                            }
                          },
                          [_vm._v("Undo")]
                        )
                      ]
                    )
              ]
            )
          }),
          0
        ),
    _vm._v(" "),
    _vm.lightbox
      ? _c(
          "div",
          {
            staticClass: "lightbox",
            on: {
              click: function($event) {
                _vm.lightbox = null
              }
            }
          },
          [
            _c("img", {
              staticClass: "lightbox-img",
              attrs: { src: _vm.lightbox }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "lightbox-close",
                on: {
                  click: function($event) {
                    _vm.lightbox = null
                  }
                }
              },
              [_vm._v("✕")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021c9b3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021c9b3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Merge_Documents.vue
// module id = 738
// module chunks = 0